import { render, staticRenderFns } from "./higher-search-model.vue?vue&type=template&id=4bffbd55&scoped=true&"
import script from "./higher-search-model.vue?vue&type=script&lang=js&"
export * from "./higher-search-model.vue?vue&type=script&lang=js&"
import style0 from "./higher-search-model.vue?vue&type=style&index=0&id=4bffbd55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bffbd55",
  null
  
)

export default component.exports